import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classNames from 'classnames';

import UserAvatar from '@adsk/bim360-matrix-react-user-avatar';
import Tooltip from '@adsk/bim360-matrix-react-tooltip';
import OverflowTooltip from '@adsk/bim360-matrix-react-overflow-tooltip';
import { DateFormats } from '@adsk/bim360-matrix-react-helpers/es/consts';

import './_ActivityBlockHeader.scss';
import { ThemeConsumer } from '@adsk/bim360-matrix-react-helpers/es/theme';

const ActivityBlockHeader = ({ className, user, container, activityTime }) => {
  const formattedActivityTime = useMemo(() => {
    const activityTimeMoment = moment(activityTime);
    const lastYear = moment().year() - 1;
    const nowOneYearAgo = moment().year(lastYear);

    return activityTimeMoment.isBefore(nowOneYearAgo)
      ? activityTimeMoment.format(DateFormats.SHORT_DATE_FORMAT)
      : activityTimeMoment.format(DateFormats.SHORT_DATE_SPACED_HOUR_NO_YEAR_FORMAT);
  }, [activityTime]);

  return (
    <ThemeConsumer>
      {({ theme }) => (
        <div
          className={classNames('ActivityBlockHeader', className, `ActivityBlockHeader--${theme}`)}
        >
          <div className="ActivityBlockHeader__user-container">
            <UserAvatar user={user} />
            <div
              className="ActivityBlockHeader__name-wrapper"
              data-testid="ActivityBlockHeader__name"
            >
              <OverflowTooltip
                tooltipClassName="ActivityBlockHeader__popover"
                container={container}
                place={Tooltip.Places.BOTTOM}
                singleLine={true}
                autoTipOnEllipsis={true}
                triggerTarget={Tooltip.TriggerTargets.TOOLTIP}
              >
                {user.name}
              </OverflowTooltip>
            </div>
          </div>
          <span className="ActivityBlockHeader__time">{formattedActivityTime}</span>
        </div>
      )}
    </ThemeConsumer>
  );
};

ActivityBlockHeader.propTypes = {
  className: PropTypes.string,
  ...UserAvatar.propTypes,
  /**
   * User as specified in UserAvatar
   */
  user: PropTypes.object.isRequired,
  /**
   * A moment object of the activity's time
   */
  activityTime: PropTypes.oneOfType([
    PropTypes.instanceOf(moment),
    PropTypes.instanceOf(Date),
    PropTypes.string
  ]).isRequired,

  /**
   * container of the Tooltip
   */
  container: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
};

ActivityBlockHeader.defaultProps = {
  container: () => document.body
};

export default ActivityBlockHeader;
